import { SearchSettings, SearchTagSettings } from "../types/search";

interface FullSearchSettings {
  search: SearchSettings;
  tags: SearchTagSettings;
}

export const initialSearchSettings: SearchSettings = {
  vessel: true,
  port: true,
  aton: true,
};

export const initialTagSettings: SearchTagSettings = {
  destination: false,
  port: false,
  vesselType: true,
};

const updateSearchSettings = ({
  search,
  tags,
}: Partial<FullSearchSettings>): void => {
  const oldSettings = localStorage.getItem("searchSettings");

  const initialSettings = {
    search: initialSearchSettings,
    tags: initialTagSettings,
  };

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const settingsToSave: FullSearchSettings = oldSettings
    ? JSON.parse(oldSettings)
    : initialSettings;

  settingsToSave.search = search ?? settingsToSave.search;
  settingsToSave.tags = tags ?? settingsToSave.tags;

  localStorage.setItem("searchSettings", JSON.stringify(settingsToSave));
};
function readSearchSettings(k: "tags"): SearchTagSettings | undefined;
function readSearchSettings(k: "search"): SearchSettings | undefined;
function readSearchSettings(
  k: keyof FullSearchSettings,
): SearchTagSettings | SearchSettings | undefined {
  const localSettings = localStorage.getItem("searchSettings");
  if (localSettings) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const parsedSettings: FullSearchSettings = JSON.parse(localSettings);
    if (k === "search" || k === "tags") {
      return parsedSettings[k];
    }
  }
  return undefined;
}

export { updateSearchSettings, readSearchSettings };
